import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconHungaryMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={375}
      height={375}
      fill="none"
      viewBox="0 0 375 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-hungary-minimap-markers_svg__a)">
        <path
          fill="url(#icon-hungary-minimap-markers_svg__b)"
          fillOpacity={0.2}
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M124.338 133.429c.74 5.509 4.542 22.163 6.35 29.801 2.564 11.79 6.535 29.995 9.873 45.165 2.432 12.715 5.551 25.089 6.005 26.755.952 3.497 4.895 5.784 6.747 6.49a2051.818 2051.818 0 0 1 17.058 6.727c4.95 1.982 9.192 3.72 10.595 4.399 3.837 1.854 11.379 7.02 8.468 18.543a13.628 13.628 0 0 1-.663 1.985c-2.215 5.231-7.195 7.324-11.441 7.948-1.782.262-3.435.265-4.699.133h-41.414c-9.658 0-16.406-1.192-31.622 1.987-3.417.713-6.881 1.882-10.227 3.284-11.552 4.84-21.695 12.466-23.644 13.802-1.923 1.317-6.092 3.176-7.767 7.239-.515 1.248-.794 2.704-.7 4.416.183 3.382 2.455 5.202 4.96 6.109 1.81.656 3.743.834 5.095.778l30.202-.124c63.791-.259 152.63-.601 187.192-.67 7.977-.016 13.062-.018 14.282 0 9.261.132 14.025-5.563 14.686-6.623.662-1.059 8.336-8.609 2.646-20.397-2.994-6.203-8.259-8.629-12.905-9.534-4.181-.816-7.86-.4-8.926-.4-.719 0-3.779.055-7.817.111-1.139.016-2.356.032-3.62.047-8.268.099-18.555.155-22.302-.158-2.439-.203-4.214-.815-5.558-1.612-2.157-1.28-3.204-3.036-4.101-4.348-1.456-2.129-2.249-6.225-.264-11.258.547-1.388 1.581-2.543 2.81-3.482 2.337-1.786 5.379-2.793 7.113-3.141H278.612c3.704 0 7.982.53 9.658.795 7.498 1.28 23.446 3.947 27.256 4.371 4.764.53 5.407-.895 6.484-2.781 1.058-1.855 1.852-10.464 1.984-12.451.055-.821.313-6.013.616-12.185.43-8.756.949-19.487 1.104-22.517.265-5.165 2.282-45.021 2.514-49.668.176-3.179.529-8.344.529-10.464 0-.923-.019-1.874-.057-2.748-.044-1.007-.113-1.911-.207-2.55-.678-5.685-3.854-9.75-7.058-12.383a23.07 23.07 0 0 0-3.297-2.263 19.074 19.074 0 0 0-1.686-.85c-4.498-1.987-21.259-7.013-28.049-9.404-7.145-2.517-8.269-3.585-11.776-6.49-3.837-3.179-7.806-9.669-8.335-10.861-.316-.711-5.291-9.242-9.676-16.743-2.968-5.077-5.666-9.682-6.467-11.072-1.099-1.907-2.157-3.448-3.49-4.76-1.073-1.055-2.325-1.962-3.919-2.79-3.782-1.963-7.277-1.721-10.585-.926a9.124 9.124 0 0 0-1.334.466c-1.413.595-3.348 1.624-5.431 2.814a236.45 236.45 0 0 0-6.335 3.78c-2.195 1.35-4.122 2.56-5.291 3.27-1.78 1.082-3.464 2.31-5.57 3.082a12.441 12.441 0 0 1-3.956.76c-3.37.105-4.356-.523-7.232-2.355l-.045-.03a1750.083 1750.083 0 0 1-8.226-6.055c-8.525-6.304-18.406-13.68-22.68-16.956a79.401 79.401 0 0 1-1.907-1.491c-3.043-2.517-2.911-3.709-2.514-6.888.397-3.179.231-5.02-1.324-6.887a5.687 5.687 0 0 0-1.122-1.025c-2.01-1.408-4.702-1.536-6.022-1.757-.94-.156-7.856-1.194-16.472-2.455a3475.05 3475.05 0 0 0-18.855-2.71c-13.852-1.946-22.618-1.364-30.471.298-.923.196-1.834.406-2.74.629-8.614 2.123-12.965 9.121-12.965 17.086 0 5.256 1.925 8.716 3.94 11.06 1.487 1.731 3.023 2.854 3.866 3.642.498.465 2.82 2.18 6.089 4.548 5.494 3.979 13.667 9.8 20.364 14.625 5.204 3.749 9.517 6.897 10.991 8.112 3.875 3.194 4.314 5.406 4.107 10.276-.033.783-.083 1.635-.138 2.571-.086 1.467-.11 3.214-.085 5.122.09 6.88.815 15.844 1.541 21.236Z"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M313.675 311.573c-.662 1.06-5.425 6.755-14.686 6.623-1.22-.017-6.305-.016-14.282 0"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M313.673 311.573c.661-1.06 8.335-8.609 2.646-20.397-2.994-6.204-8.26-8.629-12.905-9.535"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M303.416 281.642c-4.182-.816-7.861-.4-8.927-.4-.719 0-3.779.055-7.817.111"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M286.671 281.353c-1.139.016-2.356.032-3.62.047"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M283.051 281.4c-8.268.099-18.555.155-22.302-.158-2.438-.203-4.213-.815-5.558-1.612"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M253.635 260.542c-1.229.939-2.264 2.094-2.811 3.482-1.985 5.033-1.191 9.129.265 11.258.896 1.312 1.944 3.068 4.101 4.348"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M253.637 260.542c2.337-1.786 5.378-2.793 7.113-3.141h11.441"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M278.612 257.401h-6.421"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M315.524 262.567c-3.811-.424-19.758-3.091-27.256-4.371-1.676-.265-5.954-.795-9.659-.795"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M322.011 259.786c-1.077 1.886-1.72 3.311-6.484 2.781"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M322.008 259.786c1.058-1.855 1.852-10.464 1.984-12.451.055-.821.313-6.013.616-12.185"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M324.609 235.15c.43-8.756.949-19.487 1.105-22.517.264-5.165 2.281-45.021 2.513-49.668.177-3.179.53-8.344.53-10.464 0-.923-.02-1.874-.058-2.748"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M328.699 149.753c-.044-1.007-.113-1.911-.208-2.55-.678-5.685-3.854-9.75-7.057-12.383"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M321.433 134.82a23.009 23.009 0 0 0-3.296-2.263"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M258.613 88.209c4.385 7.501 9.36 16.032 9.676 16.743.529 1.192 4.498 7.682 8.335 10.861 3.508 2.906 4.631 3.973 11.776 6.49 6.79 2.392 23.551 7.417 28.05 9.404.51.225 1.08.508 1.686.85"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M258.617 88.209c-2.968-5.077-5.666-9.682-6.467-11.072-1.099-1.907-2.157-3.448-3.49-4.76"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M248.659 72.378c-1.074-1.056-2.325-1.963-3.919-2.79-3.783-1.963-7.278-1.722-10.585-.927-.361.087-.812.247-1.335.466"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M232.821 69.127c-1.413.595-3.347 1.624-5.43 2.814"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M227.39 71.94a236.713 236.713 0 0 0-6.335 3.782"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M221.056 75.722c-2.195 1.349-4.121 2.56-5.291 3.27-1.779 1.081-3.464 2.31-5.57 3.081"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M198.961 80.449c2.911 1.854 3.89 2.49 7.277 2.384a12.441 12.441 0 0 0 3.956-.76"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M198.962 80.449c-1.135-.83-2.38-1.745-3.7-2.717"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M195.26 77.732c-1.434-1.055-2.957-2.179-4.526-3.339"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M190.735 74.393c-8.525-6.304-18.406-13.679-22.68-16.956"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M168.057 57.437a80.653 80.653 0 0 1-1.906-1.491c-3.044-2.517-2.911-3.71-2.514-6.888.397-3.179.231-5.02-1.324-6.887a5.69 5.69 0 0 0-1.122-1.026"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M138.695 36.934c8.616 1.26 15.533 2.299 16.472 2.455 1.32.22 4.012.35 6.023 1.756"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M138.693 36.934a3475.05 3475.05 0 0 0-18.855-2.71c-13.851-1.946-22.618-1.364-30.47.298"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M89.37 34.522c-.924.195-1.835.406-2.74.629-8.614 2.123-12.966 9.121-12.966 17.086 0 5.256 1.926 8.716 3.94 11.06"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M77.602 63.297c1.487 1.731 3.023 2.854 3.867 3.642.497.465 2.819 2.18 6.088 4.548"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M87.559 71.487c5.494 3.979 13.666 9.8 20.364 14.624"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M118.913 94.224c-1.474-1.215-5.787-4.363-10.991-8.112"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M118.914 94.223c3.875 3.195 4.314 5.407 4.107 10.277"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M123.022 104.5c-.034.783-.084 1.635-.139 2.571-.086 1.467-.11 3.214-.085 5.122"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M122.797 112.193c.09 6.88.815 15.844 1.54 21.236.741 5.51 4.543 22.163 6.351 29.801 2.564 11.79 6.535 29.995 9.873 45.165 2.432 12.715 5.55 25.089 6.004 26.755.953 3.497 4.896 5.784 6.748 6.49a2065.75 2065.75 0 0 1 17.058 6.727"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M170.371 248.367c4.95 1.982 9.192 3.72 10.595 4.398 3.837 1.855 11.379 7.02 8.468 18.543a13.722 13.722 0 0 1-.663 1.986"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M188.769 273.294c-2.216 5.231-7.196 7.324-11.441 7.948"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M177.332 281.242c-1.782.262-3.435.265-4.7.133h-21.718"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M150.911 281.375h-19.694c-9.659 0-16.407-1.192-31.623 1.986-3.417.714-6.88 1.883-10.227 3.285"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M89.368 286.646c-11.552 4.84-21.695 12.466-23.644 13.802-1.923 1.317-6.092 3.176-7.767 7.239"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M57.957 307.687c-.515 1.248-.794 2.704-.7 4.416.183 3.382 2.455 5.202 4.96 6.109"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="m97.512 318.866-30.202.124c-1.351.056-3.284-.122-5.095-.778"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M97.512 318.866c63.791-.259 152.63-.601 187.192-.67"
        />
        <g filter="url(#icon-hungary-minimap-markers_svg__c)">
          <rect
            width={20}
            height={20}
            x={35}
            y={322}
            fill="url(#icon-hungary-minimap-markers_svg__d)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__e)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m44.827 329.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__f)">
          <rect
            width={20}
            height={20}
            x={189}
            y={282}
            fill="url(#icon-hungary-minimap-markers_svg__g)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__h)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m196.005 294.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V296h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__i)">
          <rect
            width={20}
            height={20}
            x={120}
            y={239}
            fill="url(#icon-hungary-minimap-markers_svg__j)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__k)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M126.787 251.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L131.551 253h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__l)">
          <rect
            width={20}
            height={20}
            x={131}
            y={80}
            fill="url(#icon-hungary-minimap-markers_svg__m)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__n)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M141.707 92.392h-4.08V90.82l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V94h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__o)">
          <rect
            width={20}
            height={20}
            x={83}
            y={43}
            fill="url(#icon-hungary-minimap-markers_svg__p)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__q)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M89.89 55.764V54.54h1.391v.804l.468.456h2.256l.468-.456V53.28l-.468-.468H90.01V48.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L94.63 57h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__r)">
          <rect
            width={20}
            height={20}
            x={135}
            y={46}
            fill="url(#icon-hungary-minimap-markers_svg__s)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__t)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M141.909 58.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L146.721 60h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__u)">
          <rect
            width={20}
            height={20}
            x={195}
            y={90}
            fill="url(#icon-hungary-minimap-markers_svg__v)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__w)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M201.756 102.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L206.76 104h-3.768l-1.236-1.236Zm4.248-3.612.48-.48V97.28l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__x)">
          <rect
            width={20}
            height={20}
            x={168}
            y={21}
            fill="url(#icon-hungary-minimap-markers_svg__y)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__z)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M179.161 28.028V27.8h-4.248v-1.2h5.688v1.464L177.253 35h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__A)">
          <rect
            width={20}
            height={20}
            x={232}
            y={39}
            fill="url(#icon-hungary-minimap-markers_svg__B)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__C)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M238.94 51.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L243.632 53h-3.456l-1.236-1.236Zm3.648-3.072.888-.888V46.28l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__D)">
          <rect
            width={20}
            height={20}
            x={283}
            y={89}
            fill="url(#icon-hungary-minimap-markers_svg__E)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__F)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m288.841 96.076-1.836.948V95.74l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L297.059 103h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__G)">
          <rect
            width={20}
            height={20}
            x={291}
            y={142}
            fill="url(#icon-hungary-minimap-markers_svg__H)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__I)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m298.458 149.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__J)">
          <rect
            width={20}
            height={20}
            x={323}
            y={265}
            fill="url(#icon-hungary-minimap-markers_svg__K)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__L)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m329.303 272.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V279h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__M)">
          <rect
            width={20}
            height={20}
            x={220}
            y={255}
            fill="url(#icon-hungary-minimap-markers_svg__N)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__O)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m226.134 262.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L233.92 269h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-hungary-minimap-markers_svg__P)">
          <rect
            width={20}
            height={20}
            x={316}
            y={322}
            fill="url(#icon-hungary-minimap-markers_svg__Q)"
            rx={10}
          />
          <g filter="url(#icon-hungary-minimap-markers_svg__R)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m322.274 329.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V336h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="M240.539 337.835h3.598v-4.526h-3.598zM240.539 328.784h3.598v-4.526h-3.598zM240.539 319.732h3.598v-4.526h-3.598zM240.539 310.68h3.598v-4.526h-3.598zM240.539 301.629h3.598v-4.526h-3.598zM244.137 333.309h3.598v-4.526h-3.598zM244.137 324.258h3.598v-4.526h-3.598zM244.137 315.206h3.598v-4.526h-3.598zM244.137 306.155h3.598v-4.526h-3.598z"
        />
        <path
          fill="#000"
          d="M244.137 337.835h3.598v-4.526h-3.598zM244.137 328.784h3.598v-4.526h-3.598zM244.137 319.732h3.598v-4.526h-3.598zM244.137 310.68h3.598v-4.526h-3.598zM244.137 301.629h3.598v-4.526h-3.598zM240.539 333.309h3.598v-4.526h-3.598zM240.539 324.258h3.598v-4.526h-3.598zM240.539 315.206h3.598v-4.526h-3.598zM240.539 306.155h3.598v-4.526h-3.598z"
        />
        <path
          fill="#E2645A"
          d="m217.374 345.763 13.238-9.857v19.761l-13.238-9.904Zm-2.022 0c0 .728.267 1.408.801 1.796l13.887 10.342c1.068.825 2.404-.146 2.404-1.748v-20.781c0-1.553-1.336-2.573-2.404-1.796l-13.887 10.39c-.534.437-.801 1.117-.801 1.797Z"
        />
      </g>
      <defs>
        <filter
          id="icon-hungary-minimap-markers_svg__c"
          width={36}
          height={36}
          x={27}
          y={316}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__e"
          width={19.227}
          height={24.4}
          x={34.992}
          y={321.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__f"
          width={36}
          height={36}
          x={181}
          y={276}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__h"
          width={21.832}
          height={24.4}
          x={187.957}
          y={281.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__i"
          width={36}
          height={36}
          x={112}
          y={233}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__k"
          width={22}
          height={24.4}
          x={118.785}
          y={238.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__l"
          width={36}
          height={36}
          x={123}
          y={74}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__n"
          width={22.492}
          height={24.4}
          x={129.629}
          y={79.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__o"
          width={36}
          height={36}
          x={75}
          y={37}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__q"
          width={21.973}
          height={24.4}
          x={81.891}
          y={42.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__r"
          width={36}
          height={36}
          x={127}
          y={40}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__t"
          width={22.047}
          height={24.4}
          x={133.91}
          y={45.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__u"
          width={36}
          height={36}
          x={187}
          y={84}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__w"
          width={22.242}
          height={24.4}
          x={193.754}
          y={89.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__x"
          width={36}
          height={36}
          x={160}
          y={15}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__z"
          width={21.688}
          height={24.4}
          x={166.914}
          y={20.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__A"
          width={36}
          height={36}
          x={224}
          y={33}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__C"
          width={22.047}
          height={24.4}
          x={230.82}
          y={38.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__D"
          width={36}
          height={36}
          x={275}
          y={83}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__F"
          width={27.387}
          height={24.4}
          x={279.004}
          y={88.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__G"
          width={36}
          height={36}
          x={283}
          y={136}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__I"
          width={23.969}
          height={24.4}
          x={288.621}
          y={141.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__J"
          width={36}
          height={36}
          x={315}
          y={259}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__L"
          width={26.688}
          height={24.4}
          x={319.469}
          y={264.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__M"
          width={36}
          height={36}
          x={212}
          y={249}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__O"
          width={26.859}
          height={24.4}
          x={216.297}
          y={254.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__P"
          width={36}
          height={36}
          x={308}
          y={316}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <filter
          id="icon-hungary-minimap-markers_svg__R"
          width={27.051}
          height={24.4}
          x={312.438}
          y={321.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9547_327225"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9547_327225"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9547_327225"
            result="effect2_dropShadow_9547_327225"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9547_327225"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__b"
          x1={57.238}
          x2={328.757}
          y1={177.389}
          y2={177.389}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__d"
          x1={35}
          x2={55}
          y1={332}
          y2={332}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__g"
          x1={189}
          x2={209}
          y1={292}
          y2={292}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__j"
          x1={120}
          x2={140}
          y1={249}
          y2={249}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__m"
          x1={131}
          x2={151}
          y1={90}
          y2={90}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__p"
          x1={83}
          x2={103}
          y1={53}
          y2={53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__s"
          x1={135}
          x2={155}
          y1={56}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__v"
          x1={195}
          x2={215}
          y1={100}
          y2={100}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__y"
          x1={168}
          x2={188}
          y1={31}
          y2={31}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__B"
          x1={232}
          x2={252}
          y1={49}
          y2={49}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__E"
          x1={283}
          x2={303}
          y1={99}
          y2={99}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__H"
          x1={291}
          x2={311}
          y1={152}
          y2={152}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__K"
          x1={323}
          x2={343}
          y1={275}
          y2={275}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__N"
          x1={220}
          x2={240}
          y1={265}
          y2={265}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <linearGradient
          id="icon-hungary-minimap-markers_svg__Q"
          x1={316}
          x2={336}
          y1={332}
          y2={332}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A746B" />
          <stop offset={1} stopColor="#4FC5BA" />
        </linearGradient>
        <clipPath id="icon-hungary-minimap-markers_svg__a">
          <path fill="#fff" d="M0 0h375v375H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconHungaryMinimapMarkers;
